import invert from 'lodash/invert';
import {AgreementTypeVo} from '../../common/shared/api/nicolas/vo/AgreementTypeVo.enum';
import {AgreementType} from '../generated/types';

export function createAgreementType(
  agreementTypeVo: AgreementTypeVo
): AgreementType {
  return agreementTypeVoToAgreementType[agreementTypeVo] || AgreementType.None;
}

export function createAgreementTypeVo(
  agreementType: AgreementType
): AgreementTypeVo {
  return agreementTypeToAgreementTypeVo[agreementType];
}

const agreementTypeVoToAgreementType: {
  [key in AgreementTypeVo]: AgreementType;
} = {
  [AgreementTypeVo.Friends]: AgreementType.Friends,
  [AgreementTypeVo.FreeTicketCashPresentNoti]:
    AgreementType.FreeTicketCashPresentNoti,
  [AgreementTypeVo.KakaoTerm]: AgreementType.KakaoTerm,
  [AgreementTypeVo.PersonalInformation]: AgreementType.PersonalInformation,
  [AgreementTypeVo.PersonalInformationThird]:
    AgreementType.PersonalInformationThird,
  [AgreementTypeVo.Marketing]: AgreementType.Marketing,
  [AgreementTypeVo.NightMarketing]: AgreementType.NightMarketing,
  [AgreementTypeVo.Privacy]: AgreementType.Privacy,
  [AgreementTypeVo.Under14]: AgreementType.Under14,
  [AgreementTypeVo.TermsPaid]: AgreementType.TermsPaid,
  [AgreementTypeVo.Over14]: AgreementType.Over14,
  [AgreementTypeVo.None]: AgreementType.None,
  [AgreementTypeVo.ParentPrivacy]: AgreementType.LegalAgentPrivacy,
  [AgreementTypeVo.ChildPrivacy]: AgreementType.ChildPrivacy,
  [AgreementTypeVo.ChildPersonalInformationThird]:
    AgreementType.ChildPersonalInformationThird,
  [AgreementTypeVo.ChildMarketingThird]: AgreementType.ChildMarketingThird,
};

type AgreementTypeToAgreementTypeVo = {
  [key in AgreementType]: AgreementTypeVo;
};

export const agreementTypeToAgreementTypeVo = invert(
  agreementTypeVoToAgreementType
) as AgreementTypeToAgreementTypeVo;
